<template>
  <f7-actions :class="`${actionsOpenId}`">
    <f7-actions-group>
      <f7-actions-button color="blue" @click="()=>handleSharePlace()">Share to...</f7-actions-button>
      <f7-actions-button color="blue">
        <f7-link
          v-clipboard:copy="`${constants.DOMAIN_SHARE.DOMAIN + '/' + constants.TYPE_URL.PLACE + '/' + typeId}`"
          v-clipboard:success="onCopySuccess"
          v-clipboard:error="onCopyError"
        >Copy Link</f7-link>
      </f7-actions-button>
      <input
        type="hidden"
        :v-model="`${constants.DOMAIN_SHARE.DOMAIN + '/' + constants.TYPE_URL.PLACE + '/' + typeId}`"
      >
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button color="blue" bold>Cancel</f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>
<script>
import C from "../_helpers/constants";
import { sharePlace } from "../utils/share";
import { copySuccess, copyError } from "../utils/copy";
export default {
  props: {
    actionsOpenId: {
      required: false,
      type: String
    },
    typeId: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      constants: C
    };
  },
  methods: {
    handleSharePlace(id) {
      return sharePlace(id);
    },
    onCopySuccess(e) {
      return copySuccess(e, this);
    },
    onCopyError(e) {
      return copyError(e);
    }
  }
};
</script>

